import "../styles/Kemaskini.css";

const updates = [
    { date: "14 Januari 2025", type: "Etikaf Web", title: "Website Etikaf Baru", description: "Susunatur dan rekabentuk yang baru" },
    { date: "15 Februari 2025", type: "Etikaf Admin", title: "Admin 2.0", description: "Admin 2.0 memudahkan pengurusan masjid dengan fungsi lebih kemas" },
    { date: "12 Mac 2025", type: "Asatizah", title: "Profail Asatizah & Jadual", description: "Para asatizah boleh mencipta profail dan menguruskan jadual serta tajuk pengajaran" },
    { date: "18 April 2025", type: "Asatizah", title: "Poster Pengajaran Automatik", description: "Asatizah dapat menjana poster pengajaran secara automatik" },
    { date: "20 Mei 2025", type: "Etikaf TV", title: "Paparan Ayat al-Quran", description: "Fungsi Paparan ayat al-Quran pilihan beserta tafsiran ringkas" },
    { date: "10 Jun 2025", type: "Etikaf TV", title: "Live Masjidil Haram", description: "Paparkan siaran langsung dari Masjidil Haram di skrin utama masjid" },
    { date: "31 Julai 2025", type: "Etikaf Admin", title: "Penambahan Profail Pegawai", description: "Masjid memasukkan maklumat pengurusan masjid" },
];


const Kemaskini = () => {
    return (
        <div className="kemaskini-container">
            <h2>Kemaskini Sistem</h2>
            <div className="kemaskini-list">
                {updates.map((update, index) => (
                    <div key={index} className="kemaskini-item">
                        <span className="kemaskini-date">{update.date}</span>
                        <span className="kemaskini-type">{update.type}</span>
                        <h3 className="kemaskini-title">{update.title}</h3>
                        <p className="kemaskini-description">{update.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Kemaskini;
